import { Component, Prop, Vue } from 'vue-property-decorator'

import BadgePerson from '@/components/BadgePerson/index.vue'
import BadgeCosts from '@/components/BadgeCosts/index.vue'

import tableHelper from '@/helpers/table'

import { bus } from '@/main'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faClock,
	faScroll,
	faFeatherPointed,
	faPrint,
	faBook,
	faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'

library.add(
	faClock,
	faScroll,
	faFeatherPointed,
	faPrint,
	faBook,
	faTriangleExclamation,
)

@Component({
	components: {
		BadgePerson,
		BadgeCosts,
	},
})
export default class CardInitial extends Vue {
	@Prop({ required: true }) readonly initial

	getShortDate(date) {
		if (date && typeof date !== 'string') {
			date = date.toISOString()
		}

		let result = date?.split('T')[0]
		result = result?.split('-')?.reverse()

		if (result && result.pop) {
			result.pop()
			return result.join('/')
		}

		return null
	}

	onClick(initialId) {
		bus.$emit('open-modal-initials', initialId)
	}

	getGroupName(initial) {
		const group = initial?.group

		if (group && group?.name) {
			return group?.name
		}
	}

	getSubjetcName(initial) {
		const subject = initial?.calc_subject
		if (subject && subject?.name) {
			return subject?.name
		}
	}

	getSubjetcMatter(initial) {
		const subject_matter = initial?.subject_matter
		if (subject_matter) {
			return subject_matter
		}
	}

	getModelValue(initial) {
		if (initial?.model !== null && initial?.model !== undefined) {
			return initial.model
		}
		return null
	}

	getCostsStatusClass(costsStatus) {
		let htmlClass = ''

		switch (costsStatus) {
			case 'Pré-distribuição':
				htmlClass = 'red'
				break

			case 'Pós-distribuição':
				htmlClass = 'yellow'
				break

			case 'Pós-distribuição-isenção':
				htmlClass = 'green'
				break
		}

		return htmlClass
	}

	// isTwoDaysBefore(date) {
	// 	const now = new Date()
	// 	const differenceInMs = now.getTime() - new Date(date).getTime()

	// 	const differenceInDays = differenceInMs / 1000 / 60 / 60 / 24

	// 	return differenceInDays > -2
	// }

	getClass() {
		switch (this.initial.status) {
			case 'Ok':
				return 'alert-success'
			case 'Parado':
			case 'Perdida':
				return 'alert-danger'
			case 'Protocolado':
			case '1ª Revisão':
				return 'alert-warning'
		}

		return 'alert-dark'
	}
}
